import { c as l, d as C } from "./chunk-WithApiClient-Da1nY1F5.js";
import { c as p, a as u } from "./chunk-cart-sections-BB6iP-t5.js";
import { c } from "./chunk-consume-goIJBrYG.js";
import "./chunk-lit-element-CNHURX5C.js";
import { r as h } from "./chunk-state-DXVUuFZf.js";
var m = Object.defineProperty, n = (i, s, o, e) => {
  for (var t = void 0, a = i.length - 1, r; a >= 0; a--)
    (r = i[a]) && (t = r(s, o, t) || t);
  return t && m(s, o, t), t;
};
const d = /* @__PURE__ */ new Set([]), y = "cart-drawer-dialog", w = {
  cart: !0,
  sections: !0
}, b = (i) => {
  class s extends i {
    constructor() {
      super(...arguments), this.shopifyCartLoading = !1, this.shopifyCartError = null, this.loadingCartPromise = null, this.client = l({
        baseUrl: `${window.Shopify.routes.root}cart`,
        headers: {
          "Content-Type": "application/json"
        },
        defaultMethod: "POST",
        withQueue: !0,
        queueKey: "shopify-cart",
        onRequestStart: () => {
          this.shopifyCartLoading = !0, this.classList.add("loading"), Array.from(this.querySelectorAll("button")).forEach((e) => {
            e.classList.add("disabled");
          });
        },
        onRequestEnd: () => {
          this.shopifyCartLoading = !1, this.classList.remove("loading"), Array.from(this.querySelectorAll("button")).forEach((e) => {
            e.classList.remove("disabled");
          });
        }
      });
    }
    connectedCallback() {
      super.connectedCallback();
      const e = this.getAttribute("section-id");
      e && typeof e == "string" && d.add(e);
    }
    get sectionsToFetch() {
      return Array.from(d).slice(0, 5).join(",");
    }
    async addItemToCart(e) {
      try {
        const t = await this.client(
          "/add.js",
          {
            body: {
              items: e,
              sections: this.sectionsToFetch,
              sections_url: window.location.pathname
            }
          }
        );
        return await this._handleCartAdd(
          [t.items],
          this
        ), await this._handleCartChange(), t.sections && this._handleCartSectionsChange(t.sections), t;
      } catch (t) {
        throw this._handleCartError(t), t;
      }
    }
    async addItemToWithForm(e) {
      try {
        e.append("sections", this.sectionsToFetch), e.append("sections_url", window.location.pathname);
        const t = await this.client(
          "/add",
          {
            body: e,
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/json"
            }
          },
          {
            rawBody: !0,
            removeContentType: !0
          }
        );
        return await this._handleCartAdd(
          [t],
          this
        ), await this._handleCartChange(), t.sections && this._handleCartSectionsChange(t.sections), t;
      } catch (t) {
        throw this._handleCartError(t), t;
      }
    }
    async updateQuantityToCart(e) {
      try {
        const t = await this.client("/update.js", {
          body: {
            updates: e,
            sections: this.sectionsToFetch,
            sections_url: window.location.pathname
          }
        });
        await this._handleCartChange(t), t.sections && this._handleCartSectionsChange(t.sections);
      } catch (t) {
        throw this._handleCartError(t), t;
      }
    }
    async updateCartNoteAndAttributes(e, t = w) {
      const a = await this.client("/update.js", {
        body: {
          ...e,
          sections: this.sectionsToFetch,
          sections_url: window.location.pathname
        }
      });
      await this._handleCartChange(a), t.sections && a.sections && this._handleCartSectionsChange(a.sections);
    }
    async removeItemFromCart(e) {
      const t = await this.client("/change.js", {
        body: {
          id: e,
          quantity: 0,
          sections: this.sectionsToFetch,
          sections_url: window.location.pathname
        }
      });
      await this._handleCartChange(t), t.sections && this._handleCartSectionsChange(t.sections);
    }
    async changeItemToCart(e) {
      const t = await this.client("/change.js", {
        body: {
          ...e,
          sections: this.sectionsToFetch,
          sections_url: window.location.pathname
        }
      });
      await this._handleCartChange(), t.sections && this._handleCartSectionsChange(t.sections);
    }
    async clearCart() {
      const e = await this.client("/clear.js", {
        body: {
          sections: this.sectionsToFetch,
          sections_url: window.location.pathname
        }
      });
      await this._handleCartChange(e), e.sections && this._handleCartSectionsChange(e.sections);
    }
    async getCart(e = !1) {
      var a;
      if (this.loadingCartPromise)
        return this.loadingCartPromise.promise;
      this.loadingCartPromise = C();
      const t = await this.client(".js", { method: "GET" });
      return (a = this.loadingCartPromise) == null || a.resolve(t), this.loadingCartPromise = null, e && await this.getCartSections(), t;
    }
    async _handleCartChange(e) {
      this.$emit("cart:updated", e ?? await this.getCart());
    }
    async _handleCartAdd(e, t) {
      this.$emit("cart:items-added", {
        items: e,
        target: t
      });
    }
    async getCartSections() {
      const t = await (await fetch(
        `${window.location.pathname}?sections=${this.sectionsToFetch}`
      )).json();
      return this._handleCartSectionsChange(t), t;
    }
    _handleCartSectionsChange(e) {
      e && this.$emit("cart:updated-sections", e);
    }
    _handleCartError(e) {
      this.$emit("cart:error", e), this.shopifyCartError = e;
    }
    getCartLinesForVariant(e) {
      return this.cart.items.filter((t) => t.variant_id === e);
    }
    openCartDrawer() {
      this.$emit("modal-dialog::open", y);
    }
  }
  return n([
    c({ context: p, subscribe: !0 })
  ], s.prototype, "cart"), n([
    c({ context: u, subscribe: !0 })
  ], s.prototype, "cartSections"), n([
    h()
  ], s.prototype, "shopifyCartLoading"), n([
    h()
  ], s.prototype, "shopifyCartError"), s;
};
export {
  b as W
};
